import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import { Field, TextArea, ButtonRecipe, Select } from '~/shared/components';
import { Form, ButtonContainer, Box } from './styles';
import FieldSelect from '../FieldSelect';

const MedicationInformationForm = ({ onClose }) => {
  const [maskData, setMaskData] = useState('*** **** **** ****');
  const [cnesOrCnpj, setCnesOrCnpj] = useState('');

  useEffect(() => {
    if (cnesOrCnpj === 'CNPJ') setMaskData('**.***.***/****-**');
    else setMaskData('*** **** **** ****');
  }, [cnesOrCnpj]);

  return (
    <Formik
      initialValues={{
        cnesOrCnpj: '',
        establishment: '',
        salesEmployee: '',
        pharmaceutical: '',
        email: '',
        pharmaceuticalCrf: '',
        pharmaceuticalUfCrf: '',
        describe: '',
      }}
      validationSchema={Yup.object({
        cnesOrCnpj: Yup.string().required('Campo obrigatório'),
        establishment: Yup.string().required('Campo obrigatório'),
        salesEmployee: Yup.string().required('Campo obrigatório'),
        pharmaceutical: Yup.string().required('Campo obrigatório'),
        email: Yup.string().required('Campo obrigatório'),
        pharmaceuticalCrf: Yup.string().required('Campo obrigatório'),
        pharmaceuticalUfCrf: Yup.string().required('Campo obrigatório'),
        describe: Yup.string().required('Campo obrigatório'),
      })}
      onSubmit={(values) => {
        return values;
      }}
    >
      {(props) => (
        <Form onSubmit={props.handleSubmit}>
          <Box>
            <FieldSelect
              mask={maskData}
              callBack={(event) => {
                setCnesOrCnpj(event.value);
              }}
              error={props.touched.cnesOrCnpj && props.errors.cnesOrCnpj}
              id="cnesOrCnpj"
              name="cnesOrCnpj"
              placeholder="Digite"
              label="CNES OU CNPJ"
              value={props.values.cnesOrCnpj}
              onChange={props.handleChange}
              options={[
                {
                  value: 'CNES',
                  label: 'CNES',
                },
                {
                  value: 'CNPJ',
                  label: 'CNPJ',
                },
              ]}
            />
            <Field
              error={props.touched.establishment && props.errors.establishment}
              id="establishment"
              name="establishment"
              placeholder="Digite o nome do estabelecimento"
              label="Nome do estabelecimento"
              value={props.values.establishment}
              onChange={props.handleChange}
            />
          </Box>

          <Box>
            <Field
              error={props.touched.salesEmployee && props.errors.salesEmployee}
              id="salesEmployee"
              name="salesEmployee"
              placeholder="Nome do funcionário venda"
              label="Nome do funcionário venda"
              value={props.values.salesEmployee}
              onChange={props.handleChange}
            />

            <Field
              error={
                props.touched.pharmaceutical && props.errors.pharmaceutical
              }
              id="pharmaceutical"
              name="pharmaceutical"
              placeholder="Nome do farmacêutico"
              label="Nome do farmacêutico"
              value={props.values.pharmaceutical}
              onChange={props.handleChange}
            />
          </Box>

          <Box>
            <Field
              error={props.touched.email && props.errors.email}
              id="email"
              name="email"
              placeholder="Digite o e-mail"
              label="e-mail"
              value={props.values.email}
              onChange={props.handleChange}
            />

            <Box>
              <Field
                error={
                  props.touched.pharmaceuticalCrf &&
                  props.errors.pharmaceuticalCrf
                }
                id="pharmaceuticalCrf"
                name="pharmaceuticalCrf"
                placeholder="Digite o número"
                label="Nº CRF Farmacêutico"
                value={props.values.pharmaceuticalCrf}
                onChange={props.handleChange}
              />
              <Select
                error={
                  props.touched.pharmaceuticalUfCrf &&
                  props.errors.pharmaceuticalUfCrf
                }
                id="pharmaceuticalUfCrf"
                name="pharmaceuticalUfCrf"
                placeholder="Selecione"
                label="UF CRF"
                data={[
                  {
                    value: '1',
                    label: 'Jorge',
                  },
                ]}
                value={props.values.pharmaceuticalUfCrf}
                onChange={props.handleChange}
              />
            </Box>
          </Box>
          <Box>
            <TextArea
              error={props.touched.describe && props.errors.describe}
              id="describe"
              name="describe"
              placeholder="Itens comprados"
              label="Descrição itens comprados"
              value={props.values.describe}
              onChange={props.handleChange}
            />
          </Box>

          <ButtonContainer>
            <ButtonRecipe
              type="button"
              width="111px"
              textColor="#2196f3"
              backgroundColor="#F9F9FB"
              borderColor="#2493EB"
              onClick={onClose}
            >
              Cancelar
            </ButtonRecipe>
            <ButtonRecipe
              type="submit"
              width="152px"
              textColor="#fff"
              backgroundColor="#2493EB"
              borderColor="#2493EB"
              marginLeft="20px"
              marginRight="none"
            >
              Informar Compra
            </ButtonRecipe>
          </ButtonContainer>
        </Form>
      )}
    </Formik>
  );
};

MedicationInformationForm.propTypes = {
  onClose: PropTypes.func,
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  touched: PropTypes.func.isRequired,
  errors: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
};
MedicationInformationForm.defaultProps = {
  onClose: () => {},
};

export default MedicationInformationForm;
